import React, { useState } from 'react';
import * as C from '../../Onboarding/Common.styles';
import {useSelector} from 'react-redux';

import UserForm from '../UserForm/UserForm';
import RegisterSuccess from '../Success/Success';
import RegesterFail from '../RegisterFail/RegisterFail';


const SignUpBlock = ({onSignUp}) => {

    const errorState = useSelector( state => {
        return state.preRegister.errorState;
    })

    const success = useSelector( state => {
        return state.preRegister.success;
    })


    const regsiterUser  = (data) => {
        let fd = new FormData();
        for (let key in data) {
        fd.append(key, data[key]);
        }
        onSignUp(fd);
    }

    let userForm =  <UserForm register= {data => regsiterUser(data)} />;

    if(success){
        userForm =  <RegisterSuccess />;
    }

    if(errorState){
        userForm =  <RegesterFail />
    }


    return (
        <C.SignUpMainWrapper>
            <C.SignUpWhiteOuterWrapper>
                <C.SignUpWhiteInner>
                    {userForm}
                </C.SignUpWhiteInner>
            </C.SignUpWhiteOuterWrapper>
        </C.SignUpMainWrapper>
        
    );
}

export default SignUpBlock;